// extracted by mini-css-extract-plugin
module.exports = {"label":"Products_label__3gTru","product":"Products_product__26Rs3","productName":"Products_productName__ldkxd"};